export interface JobSearchCardOption {
    key: string;
    value: string;
}

export const countries: JobSearchCardOption[] = [
    { key: 'at', value: 'Austria' },
    { key: 'be', value: 'Belgium' },
    { key: 'br', value: 'Brazil' },
    { key: 'hr', value: 'Croatia' },
    { key: 'fr', value: 'France' },
    { key: 'de', value: 'Germany' },
    { key: 'in', value: 'India' },
    { key: 'it', value: 'Italy' },
    { key: 'lu', value: 'Luxembourg' },
    { key: 'pl', value: 'Poland' },
    { key: 'ro', value: 'Romania' },
    { key: 'uk', value: 'United Kingdom' },
    { key: 'us', value: 'United States' }
];

export const roles: JobSearchCardOption[] = [
    { key: 'student', value: 'Student' },
    { key: 'professional', value: 'Professional' },
    { key: 'career_starter', value: 'Career Starter' }
];